import React, {Component} from 'react';

class JobRecruiterWidgetScripts extends Component {

    state = {
        scriptsLoaded: false,
        scriptsLoaderTimer: null
    };

    // eslint-disable-next-line react/sort-comp
    scriptsLoadedTimer = () => {
        this.setState({scriptsLoadedTimer: setInterval(() => {

            // Only load the scripts once
            if (this.state.scriptsLoaded) {
                clearInterval(this.state.scriptsLoadedTimer);
                return;
            }

            // Check for presence of window.widget
            if (!window.widget) return;

            // Load the Widget scripts
            const element = document.getElementById('jobRecruiterWidget');
            if (element && !this.state.scriptsLoaded) {
                window.widget({
                    "company_code": "MarketAxess",
                    "bg_color_widget": "#ffffff",
                    "bg_color_headers": "#005687",
                    "bg_color_links": "#a2b1c8",
                    "txt_color_headers": "#ffffff",
                    "txt_color_job": "#3d3d3d",
                    "bg_color_even_row": "#e0e0e0",
                    "bg_color_odd_row": "#f7f7f7",
                    "auto_width": "auto",
                    "auto_height": "auto",
                    "number": "on",
                    "job_title": "true",
                    "location": "true",
                    "type_of_employment": "true",
                    "department": "true",
                    "dateFormat": "us",
                    "add_search": "true",
                    "departments_field_id": "5cdd7475f4428a0006880a5f",
                    "jobAdType": "PUBLIC",
                    "trid": "",
                    "api_url": "https://www.smartrecruiters.com",
                    "custom_css_url": "https://static.smartrecruiters.com/job-widget/1.5.2/css/smart_widget.css"
                }, 'jobRecruiterWidget');
                this.setState({scriptsLoaded: true});
            }
        }, 500)});
    }

    componentWillMount() {
        this.scriptsLoadedTimer();
    }

    componentWillUnmount() {
        clearInterval(this.state.scriptsLoadedTimer);
    }

    render() {
        return (<div className="job_widget_inner"/>);
    }
}

export default JobRecruiterWidgetScripts;



// WEBPACK FOOTER //
// ./frontend/components/JobRecruiterWidget/JobRecruiterWidgetScripts.jsx